var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9597 31.3354C26.2401 31.3354 32.1421 25.4335 32.1421 18.1531C32.1421 10.8726 26.2401 4.9707 18.9597 4.9707C11.6793 4.9707 5.77734 10.8726 5.77734 18.1531C5.77734 25.4335 11.6793 31.3354 18.9597 31.3354Z",
    stroke: "#9F3030",
    strokeWidth: 1.46471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7773 27C19.8819 27 20.7773 26.1046 20.7773 25C20.7773 23.8954 19.8819 23 18.7773 23C17.6728 23 16.7773 23.8954 16.7773 25C16.7773 26.1046 17.6728 27 18.7773 27Z",
    fill: "#9F3030"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.7773,
    y: 8,
    width: 2,
    height: 13,
    rx: 1,
    fill: "#9F3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationSign);
export default __webpack_public_path__ + "static/media/exclamation_sign.07952ae1fd3ecf11c2a3da25cbebba47.svg";
export { ForwardRef as ReactComponent };